import React, { useEffect, useState } from "react";
import { HiOutlineSearch } from "react-icons/hi";

const SearchInput = ({ 
    value, 
    onChange, 
    onResetPage, 
    delay = 300, 
    placeholder = "Pesquisar...",
    className = "" 
}) => {
    const [internalValue, setInternalValue] = useState(value);

    useEffect(() => {
        setInternalValue(value);
    }, [value]);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (internalValue !== value) {
                onChange(internalValue);
                if (onResetPage) onResetPage();
            }
        }, delay);

        return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [internalValue]);

    return (
        <div className={`relative w-full ${className}`}>
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <HiOutlineSearch className="text-slate-400 text-lg" />
            </div>

            <input
                type="search"
                className="w-full h-10 pl-10 pr-4 text-sm bg-white border border-slate-300 rounded-lg shadow-sm placeholder-slate-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors"
                placeholder={placeholder}
                value={internalValue}
                onChange={(e) => setInternalValue(e.target.value)}
            />
        </div>
    );
};

export default SearchInput;